/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box } from '@mui/material';
import { MutableRefObject } from 'react';

import { PageNameType } from '../../../redux/clientConfiguration/clientConfigurationSlice';
import { CustomGridApi } from '../XTable/types';
import InfoArrays from './InfoArrays';
import InfoDocuments from './InfoDocuments';
import InfoList from './InfoList';

const CommonSidebar = ({
 item,
 apiRef,
 pageName,
}: {
 item: any;
 apiRef: MutableRefObject<CustomGridApi>;
 pageName: PageNameType;
}) => {
 return (
  item?.Id && (
   // pb: 0 because last child has pb

   <Box sx={{ px: 3, py: 2 }}>
    <InfoList data={item} />
    {['customers', 'vehicles', 'drivers'].includes(pageName) && (
     <InfoDocuments id={item.Id} table={pageName} />
    )}
    <InfoArrays id={item.Id} apiRef={apiRef} table={pageName} />
   </Box>
  )
 );
};
export default CommonSidebar;

